import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=5e20d5e1&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e20d5e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e20d5e1')) {
      api.createRecord('5e20d5e1', component.options)
    } else {
      api.reload('5e20d5e1', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=5e20d5e1&scoped=true&", function () {
      api.rerender('5e20d5e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24b1xc5kt91N2/JS/comp/SearchFilterTokens.vue"
export default component.exports